module.exports = __webpack_public_path__ + "static/media/selection-1.5e0fd85e.jpg";